export default __webpack_public_path__ + "static/media/LightWave.c6f700ed.svg";